// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"80be0473149b10abb4c8","293":"f1bd6570690ba2ba4fab","522":"e9fb79faa67234c9ad5b"}[chunkId] + ".js";
};